import React, {useState, useEffect, useRef} from "react";
import Menu from "../../../../components/layout/menu/index";
import addSurvey from "../../../../assets/images/icons/surveys/add-survey.svg"
import {getAllSurveys, softDeleteSurvey, closeSurvey, sendSurveyReminder} from "../../../../client/surveys/index"
import formIconDisabled from "../../../../assets/images/icons/surveys/form-disabled.svg"
import { useNavigate } from "react-router-dom";
import ModalSuccess from "../../../../components/shared/modals/modalSuccess";
import ModalAlertWarning from "../../../../components/shared/modals/modalAlertWarning"
import ModalDelete from "../../../../components/shared/modals/modalDelete";
import ContentLoader from "react-content-loader";


export default function SurveyAdmin() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const navigate = useNavigate();

  const [activeSurveys, setActiveSurveys] = useState([]);
  const [closedSurveys, setClosedSurveys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const [openOptionsId, setOpenOptionsId] = useState(null);
  const optionsMenuRef = useRef(null); 
  
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [showModalSuccess, setShowModalSuccess] = useState(false);
  const [showModalAlertWarning, setShowModalAlertWarning] = useState(false); 
  const [surveyToDelete, setSurveyToDelete] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [warningMessage, setWarningMessage] = useState(""); 
  const [isSendingReminders, setIsSendingReminders] = useState(false); 
  
  const [selectedSurveys, setSelectedSurveys] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [excelReport, setExcelReport] = useState(null);

  const toggleOptions = (surveyId) => {
    setOpenOptionsId(openOptionsId === surveyId ? null : surveyId);
  };

  const closeAllOptions = () => {
    setOpenOptionsId(null);
  };

  const handleSurveySelect = (surveyId) => {
    setSelectedSurveys(prev => {
      if (prev.includes(surveyId)) {
        return prev.filter(id => id !== surveyId);
      } else {
        return [...prev, surveyId];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedSurveys([]);
    } else {
      const allActiveSurveyIds = activeSurveys.map(survey => survey.id);
      setSelectedSurveys(allActiveSurveyIds);
    }
    setSelectAll(!selectAll);
  };

  useEffect(() => {
    if (activeSurveys.length > 0) {
      setSelectAll(selectedSurveys.length === activeSurveys.length);
    }
  }, [selectedSurveys, activeSurveys]);

  const handleSendReminders = async () => {
    if (selectedSurveys.length === 0) return;

    try {
      setIsSendingReminders(true);
      
   //   const response = await sendSurveyReminder(selectedSurveys, true); // testMode = true para pruebas
      const response = await sendSurveyReminder(selectedSurveys, false); // testMode = false para prod

      if (response.status === 200) {
        const result = response.data;
        
      if (result.message && result.message.includes("No hay usuarios pendientes")) {
        setWarningMessage(result.message);
        setShowModalAlertWarning(true);
      } else {
        setSuccessMessage(`Recordatorios enviados exitosamente! 
          ${result.summary.totalEmailsSent} correos enviados a 
          ${result.summary.totalUsersWithPendingSurvey} usuarios con encuestas pendientes.
          `);

        if (result.excelReport) {
          setExcelReport({
            base64: result.excelReport.base64,
            contentType: result.excelReport.contentType,
            fileName: result.excelReport.fileName
          });
        }
        
        setShowModalSuccess(true);
      }
        
        setSelectedSurveys([]);
        setSelectAll(false);
      }
    } catch (error) {
      console.error("Error sending reminders:", error);
      let errorMsg = "Error al enviar los recordatorios.";
      
    if (error.response) {
      if (error.response.status === 200 && error.response.data.message && 
          error.response.data.message.includes("No hay usuarios pendientes")) {
        setWarningMessage(error.response.data.message);
        setShowModalAlertWarning(true);
        return;
      }
      
      errorMsg = error.response.data.message || errorMsg;
      
      if (error.response.status === 400) {
        errorMsg = "Debe seleccionar al menos una encuesta para enviar recordatorios.";
      } else if (error.response.status === 404) {
        errorMsg = "No se encontraron encuestas activas con los IDs seleccionados.";
      }
    }
      
      setWarningMessage(errorMsg);
      setShowModalAlertWarning(true);
    } finally {
      setIsSendingReminders(false);
    }
  };
  
  const closeModalAlertWarning = () => {
    setShowModalAlertWarning(false);
    setWarningMessage("");
  };

  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (optionsMenuRef.current && !optionsMenuRef.current.contains(event.target)) {
        const isOptionsButton = event.target.closest('.options-button');
        if (!isOptionsButton) {
          closeAllOptions();
        }
      }
    };

    if (openOptionsId !== null) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [openOptionsId]);
  
const loadSurveys = async () => {
  try {
    setLoading(true);
    
    const response = await getAllSurveys();
    
    setActiveSurveys(response.data.activeSurveys || []);
    setClosedSurveys(response.data.closedSurveys || []);

    setSelectedSurveys([]);
    setSelectAll(false);
    
  } catch (err) {
    setError("Error al cargar las encuestas");
    console.error("Error loading surveys:", err);
  } finally {
    setLoading(false);
  }
};

  const handleViewResponses = (surveyId, surveyTitle) => {
    closeAllOptions();
    navigate(`/respuestas-encuesta/${surveyId}`, { 
      state: { surveyTitle }
    });
  };

  const handleCreateNewForm = () => {
    navigate("/crear-encuesta");
  };

  const handleDeleteClick = (surveyId, surveyTitle) => {
    closeAllOptions();
    setSurveyToDelete({ id: surveyId, title: surveyTitle });
    setShowModalDelete(true);
  };

  const handleCloseSurvey = async (surveyId, surveyTitle) => {
    closeAllOptions();
    
    try {
      const response = await closeSurvey(surveyId);
      
      if (response.status === 200) {
        setSuccessMessage("Encuesta finalizada correctamente.");
        setShowModalSuccess(true);
        
        await loadSurveys();
      }
    } catch (error) {
      console.error("Error closing survey:", error);
      let errorMsg = "Error al finalizar la encuesta.";
      
      if (error.response) {
        errorMsg = error.response.data.message || errorMsg;
      }
      
      setSuccessMessage(errorMsg);
      setShowModalSuccess(true);
    }
  };

  const handleConfirmDelete = async () => {
    if (!surveyToDelete) return;

    try {
      const response = await softDeleteSurvey(surveyToDelete.id);
      
      if (response.status === 200) {
        setSuccessMessage("Encuesta eliminada correctamente.");
        setShowModalSuccess(true);
        
        await loadSurveys();
      }
    } catch (error) {
      console.error("Error deleting survey:", error);
      setSuccessMessage("Error al eliminar la encuesta.");
      setShowModalSuccess(true);
    } finally {
      setShowModalDelete(false);
      setSurveyToDelete(null);
    }
  };

  const closeModalDelete = () => {
    setShowModalDelete(false);
    setSurveyToDelete(null);
  };

  const closeModalSuccess = () => {
    setShowModalSuccess(false);
    setExcelReport(null);
  };

  useEffect(() => {
    loadSurveys();
  }, []);

  const SurveyLoader = () => (
    <ContentLoader 
      speed={2}
      width={120}
      height={140}
      viewBox="0 0 120 140"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      className="flex flex-col items-center justify-center"
    >
      <rect x="20" y="10" rx="8" ry="8" width="80" height="80" />
      <rect x="10" y="100" rx="3" ry="3" width="100" height="12" />
      <rect x="20" y="118" rx="3" ry="3" width="80" height="10" />
    </ContentLoader>
  );

  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
        <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} bg-[#F7F8F9] w-full z-50 min-h-screen`}>
            <div className="sm:pt-8 pt-5 pb-10 sm:px-[3%] px-[5%] flex flex-col gap-4">
              <h1 className="text-blue font-itcbold text-2xl md:text-[32px]">
                Encuesta de Satisfacción
              </h1>
                <>
                <div className="flex flex-col items-start justify-between gap-3 sm:items-center sm:flex-row">
                  <h2 className="text-xl md:text-2xl text-blue font-itcmedium">Crear Formulario</h2>
                  <div className="flex items-center gap-4">
                    {selectedSurveys.length > 0 && (
                      <div className="text-sm text-blue font-itcbook">
                        {selectedSurveys.length} encuesta(s) seleccionada(s)
                      </div>
                    )}
                  <button 
                    onClick={handleSendReminders}
                    disabled={isSendingReminders || selectedSurveys.length === 0}
                    className={`flex items-center justify-center gap-2 p-2 px-3 transition-all duration-200 ease-in-out rounded-lg 
                      ${isSendingReminders || selectedSurveys.length === 0
                        ? 'bg-gray-400 cursor-not-allowed' 
                        : 'bg-blue-light hover:opacity-90 hover:scale-105 group'
                      }`}
                  >
                    {isSendingReminders ? (
                      <>
                        <div className="w-4 h-4 border-2 border-white rounded-full border-t-transparent animate-spin"></div>
                        <p className="text-sm text-white font-itcbook">Enviando...</p>
                      </>
                    ) : (
                      <>
                        <p className="text-sm text-white transition-colors duration-200 font-itcbook group-hover:text-blue-950 group-hover:font-itcdemi">
                          Enviar recordatorio
                        </p>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"         className="group-hover:[&>path]:stroke-blue-950 transition-colors duration-200">
                          <path d="M12 6.43994V9.76994" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" className="transition-colors duration-200"/>
                          <path d="M12.0199 2C8.3399 2 5.3599 4.98 5.3599 8.66V10.76C5.3599 11.44 5.0799 12.46 4.7299 13.04L3.4599 15.16C2.6799 16.47 3.2199 17.93 4.6599 18.41C9.4399 20 14.6099 20 19.3899 18.41C20.7399 17.96 21.3199 16.38 20.5899 15.16L19.3199 13.04C18.9699 12.46 18.6899 11.43 18.6899 10.76V8.66C18.6799 5 15.6799 2 12.0199 2Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" className="transition-colors duration-200"/>
                          <path d="M15.3299 18.8201C15.3299 20.6501 13.8299 22.1501 11.9999 22.1501C11.0899 22.1501 10.2499 21.7701 9.64992 21.1701C9.04992 20.5701 8.66992 19.7301 8.66992 18.8201" stroke="white" stroke-width="1.5" stroke-miterlimit="10" className="transition-colors duration-200"/>
                        </svg>
                      </>
                    )}
                  </button>
                  </div>
                </div>   

                  {activeSurveys.length > 0 && (
                    <div className="flex items-center gap-2 ">
                      <input
                        type="checkbox"
                        id="selectAll"
                        checked={selectAll}
                        onChange={handleSelectAll}
                        className="w-4 h-4 transition-colors duration-200 bg-white border-2 rounded-sm appearance-none cursor-pointer border-gray checked:border-[#91C24F] checked:bg-green"
                      />
                      <label htmlFor="selectAll" className="text-sm text-gray-700 cursor-pointer font-itcbook">
                        {selectAll ? 'Deseleccionar todas' : 'Seleccionar todas'} las encuestas activas
                      </label>
                    </div>
                  )}            
                  <div className="grid items-start grid-cols-2 gap-10 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5">
                    <button
                      onClick={handleCreateNewForm}
                      className="flex flex-col items-center justify-center">
                      <img src={addSurvey} alt="Crear formulario"/>
                      <p className="text-[#6B7280] text-center font-itcbook text-base md:text-xl">Nuevo formulario</p>
                    </button>
                    {loading ? (
                      <>
                        {[...Array(4)].map((_, index) => (
                          <SurveyLoader key={index} />
                        ))}
                      </>
                    ) : error ? (
                      <p className="text-red-500">{error}</p>
                    ) : (
                      activeSurveys.map(survey => (
                      <>
                        <div 
                          key={survey.id} 
                          className="relative flex flex-col items-center justify-center w-full gap-3 mt-4"
                        >
                            <div className="relative">
                              <svg width="96" height="96" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M63.3333 0H7.91667C3.5625 0 0 3.5625 0 7.91667V63.3333C0 67.6875 3.5625 71.25 7.91667 71.25H63.3333C67.6875 71.25 71.25 67.6875 71.25 63.3333V7.91667C71.25 3.5625 67.6875 0 63.3333 0ZM15.8333 15.8333H23.75V23.75H15.8333V15.8333ZM15.8333 31.6667H23.75V39.5833H15.8333V31.6667ZM15.8333 47.5H23.75V55.4167H15.8333V47.5ZM55.4167 55.4167H31.6667V47.5H55.4167V55.4167ZM55.4167 39.5833H31.6667V31.6667H55.4167V39.5833ZM55.4167 23.75H31.6667V15.8333H55.4167V23.75Z" fill="#007696"/>
                              </svg>

                              <div className="absolute inset-0 w-[96px] h-[96px] transition-opacity duration-200 bg-black rounded-xl bg-opacity-25 ">
                                  <div className="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
                                    <input 
                                      type="checkbox"
                                      checked={selectedSurveys.includes(survey.id)}
                                      onChange={() => handleSurveySelect(survey.id)}
                                      className="w-5 h-5 transition-colors duration-200 bg-white border-4 rounded-sm appearance-none cursor-pointer border-gray checked:border-[#91C24F] checked:bg-green "
                                    />
                                  </div>
                              </div>
                            </div>
                              <p className="text-[#6B7280]  font-itcbook text-center text-base md:text-xl">
                                {survey.title}
                              </p>

                            <div 
                              className="absolute right-0 top-16">
                              <div 
                                  className={`cursor-pointer relative w-6 h-6 rounded-full transition-colors duration-200 options-button 
                                    ${openOptionsId === survey.id ? 'bg-[#E8F2F5] ' : ''
                                  }`}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    toggleOptions(survey.id);
                                  }}
                                  onPointerDown={(e) => e.stopPropagation()} 
                                >
                                  <svg onPointerDown={(e) => e.stopPropagation()}  className="relative z-10" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 7C11.4696 7 10.9609 6.78929 10.5858 6.41421C10.2107 6.03914 10 5.53043 10 5C10 4.46957 10.2107 3.96086 10.5858 3.58579C10.9609 3.21071 11.4696 3 12 3C12.5304 3 13.0391 3.21071 13.4142 3.58579C13.7893 3.96086 14 4.46957 14 5C14 5.53043 13.7893 6.03914 13.4142 6.41421C13.0391 6.78929 12.5304 7 12 7ZM12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10C12.5304 10 13.0391 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14ZM12 21C11.4696 21 10.9609 20.7893 10.5858 20.4142C10.2107 20.0391 10 19.5304 10 19C10 18.4696 10.2107 17.9609 10.5858 17.5858C10.9609 17.2107 11.4696 17 12 17C12.5304 17 13.0391 17.2107 13.4142 17.5858C13.7893 17.9609 14 18.4696 14 19C14 19.5304 13.7893 20.0391 13.4142 20.4142C13.0391 20.7893 12.5304 21 12 21Z" fill="#007696"/>
                                  </svg>
                        
                                  {openOptionsId === survey.id && (
                                    <div 
                                      ref={optionsMenuRef} 
                                      className={`absolute z-10 left-0 bottom-8 options-menu`}>
                                      <div className="bg-blue rounded-lg p-1 px-2 w-[42px] h-[130px]  grid grid-rows-4 divide-y divide-white">
                                        {/**RESPUESTAS */}
    
                                        <button
                                          title="Ver respuestas"
                                          className="flex items-center justify-center w-full h-full"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleViewResponses(survey.id, survey.title);
                                          }}
                                          >
                                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.886719 8.75C1.59172 4.91 4.95622 2 9.00022 2C13.0442 2 16.4087 4.91 17.1145 8.75C16.4095 12.59 13.0442 15.5 9.00022 15.5C4.95622 15.5 1.59172 12.59 0.886719 8.75ZM9.00022 12.5C9.99478 12.5 10.9486 12.1049 11.6519 11.4017C12.3551 10.6984 12.7502 9.74456 12.7502 8.75C12.7502 7.75544 12.3551 6.80161 11.6519 6.09835C10.9486 5.39509 9.99478 5 9.00022 5C8.00566 5 7.05183 5.39509 6.34857 6.09835C5.64531 6.80161 5.25022 7.75544 5.25022 8.75C5.25022 9.74456 5.64531 10.6984 6.34857 11.4017C7.05183 12.1049 8.00566 12.5 9.00022 12.5ZM9.00022 11C8.40348 11 7.83118 10.7629 7.40923 10.341C6.98727 9.91903 6.75022 9.34674 6.75022 8.75C6.75022 8.15326 6.98727 7.58097 7.40923 7.15901C7.83118 6.73705 8.40348 6.5 9.00022 6.5C9.59696 6.5 10.1693 6.73705 10.5912 7.15901C11.0132 7.58097 11.2502 8.15326 11.2502 8.75C11.2502 9.34674 11.0132 9.91903 10.5912 10.341C10.1693 10.7629 9.59696 11 9.00022 11Z" fill="white"/>
                                          </svg>
                                            
                                        </button>
    
                                        {/** EDITAR */}
                                        <button
                                          className="flex items-center justify-center w-full h-full"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            closeAllOptions();
                                            navigate(`/actualizar-encuesta/${survey.id}`);
                                          }}
                                          title="Editar"
                                        >
                                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4 21.2852C3.71667 21.2852 3.47933 21.1892 3.288 20.9972C3.09667 20.8052 3.00067 20.5678 3 20.2852V17.8602C3 17.5935 3.05 17.3392 3.15 17.0972C3.25 16.8552 3.39167 16.6428 3.575 16.4602L16.2 3.86016C16.4 3.67682 16.621 3.53516 16.863 3.43516C17.105 3.33516 17.359 3.28516 17.625 3.28516C17.891 3.28516 18.1493 3.33516 18.4 3.43516C18.6507 3.53516 18.8673 3.68516 19.05 3.88516L20.425 5.28516C20.625 5.46849 20.7707 5.68516 20.862 5.93516C20.9533 6.18516 20.9993 6.43516 21 6.68516C21 6.95182 20.954 7.20616 20.862 7.44816C20.77 7.69016 20.6243 7.91082 20.425 8.11016L7.825 20.7102C7.64167 20.8935 7.429 21.0352 7.187 21.1352C6.945 21.2352 6.691 21.2852 6.425 21.2852H4ZM17.6 8.08516L19 6.68516L17.6 5.28516L16.2 6.68516L17.6 8.08516Z" fill="white"/>
                                          </svg>
                                        </button>
                                        {/** ELIMINAR */}
                                        <button 
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleDeleteClick(survey.id, survey.title);
                                          }}
                                          title="Eliminar"
                                          className="flex items-center justify-center w-full h-full">
                                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.241 4.00616L15.534 6.03516H19.5C19.6989 6.03516 19.8897 6.11417 20.0303 6.25483C20.171 6.39548 20.25 6.58624 20.25 6.78516C20.25 6.98407 20.171 7.17483 20.0303 7.31549C19.8897 7.45614 19.6989 7.53516 19.5 7.53516H18.731L17.858 17.7202C17.805 18.3402 17.762 18.8502 17.693 19.2622C17.623 19.6912 17.516 20.0752 17.307 20.4312C16.9788 20.9903 16.4909 21.4385 15.906 21.7182C15.534 21.8952 15.142 21.9682 14.708 22.0022C14.291 22.0352 13.78 22.0352 13.158 22.0352H10.842C10.22 22.0352 9.709 22.0352 9.292 22.0022C8.858 21.9682 8.466 21.8952 8.094 21.7182C7.50908 21.4385 7.02118 20.9903 6.693 20.4312C6.483 20.0752 6.378 19.6912 6.307 19.2622C6.238 18.8492 6.195 18.3402 6.142 17.7202L5.269 7.53516H4.5C4.30109 7.53516 4.11032 7.45614 3.96967 7.31549C3.82902 7.17483 3.75 6.98407 3.75 6.78516C3.75 6.58624 3.82902 6.39548 3.96967 6.25483C4.11032 6.11417 4.30109 6.03516 4.5 6.03516H8.466L8.759 4.00616L8.77 3.94516C8.952 3.15516 9.63 2.53516 10.48 2.53516H13.52C14.37 2.53516 15.048 3.15516 15.23 3.94516L15.241 4.00616ZM9.981 6.03516H14.018L13.762 4.25916C13.714 4.09216 13.592 4.03516 13.519 4.03516H10.481C10.408 4.03516 10.286 4.09216 10.238 4.25916L9.981 6.03516ZM11.25 10.7852C11.25 10.5862 11.171 10.3955 11.0303 10.2548C10.8897 10.1142 10.6989 10.0352 10.5 10.0352C10.3011 10.0352 10.1103 10.1142 9.96967 10.2548C9.82902 10.3955 9.75 10.5862 9.75 10.7852V15.7852C9.75 15.9841 9.82902 16.1748 9.96967 16.3155C10.1103 16.4561 10.3011 16.5352 10.5 16.5352C10.6989 16.5352 10.8897 16.4561 11.0303 16.3155C11.171 16.1748 11.25 15.9841 11.25 15.7852V10.7852ZM14.25 10.7852C14.25 10.5862 14.171 10.3955 14.0303 10.2548C13.8897 10.1142 13.6989 10.0352 13.5 10.0352C13.3011 10.0352 13.1103 10.1142 12.9697 10.2548C12.829 10.3955 12.75 10.5862 12.75 10.7852V15.7852C12.75 15.9841 12.829 16.1748 12.9697 16.3155C13.1103 16.4561 13.3011 16.5352 13.5 16.5352C13.6989 16.5352 13.8897 16.4561 14.0303 16.3155C14.171 16.1748 14.25 15.9841 14.25 15.7852V10.7852Z" fill="white"/>
                                          </svg>
                                        </button>

                                        {/**FINALIZAR ENCUESTA */}
                                        <button 
                                          title="Finalizar"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleCloseSurvey(survey.id, survey.title);
                                          }}
                                          className="flex items-center justify-center w-full h-full">
                                          <svg width="23" height="23" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M16.8203 1.90991H7.18031C5.06031 1.90991 3.32031 3.64991 3.32031 5.76991V19.8599C3.32031 21.6599 4.61031 22.4199 6.19031 21.5499L11.0703 18.8399C11.5903 18.5499 12.4303 18.5499 12.9403 18.8399L17.8203 21.5499C19.4003 22.4299 20.6903 21.6699 20.6903 19.8599V5.76991C20.6803 3.64991 18.9503 1.90991 16.8203 1.90991ZM15.6203 9.02991L11.6203 13.0299C11.4703 13.1799 11.2803 13.2499 11.0903 13.2499C10.9003 13.2499 10.7103 13.1799 10.5603 13.0299L9.06031 11.5299C8.77031 11.2399 8.77031 10.7599 9.06031 10.4699C9.35031 10.1799 9.83031 10.1799 10.1203 10.4699L11.0903 11.4399L14.5603 7.96991C14.8503 7.67991 15.3303 7.67991 15.6203 7.96991C15.9103 8.25991 15.9103 8.73991 15.6203 9.02991Z" fill="white"/>
                                          </svg>

                                        </button>
                                      </div>
                                    </div>
                                  )}
                              </div>
                            </div>
                        </div>
                      </>
                    ))
                    )}
                  </div>

                  <h2 className="pt-6 text-xl md:text-2xl text-blue font-itcmedium">
                    Todos los formularios finalizados
                  </h2>

                  <div className="grid items-start grid-cols-2 gap-10 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5">
                    {loading ? (
                    <>
                      {[...Array(5)].map((_, index) => (
                        <SurveyLoader key={index} />
                      ))}
                    </>
                    ) : error ? (
                      <p className="text-red-500">{error}</p>
                    ) : closedSurveys.length === 0 ? (
                      <p className="col-span-5 text-gray-500">No hay formularios finalizados</p>
                    ) : (
                      closedSurveys.map(survey => (
                        <div 
                          key={survey.id} 
                          className="flex flex-col items-center justify-center"
                        >
                          <img src={formIconDisabled} alt={survey.title} />
                          <p className="text-[#6B7280] font-itcbook text-center text-base md:text-xl">
                            {survey.title}
                          </p>
                        </div>
                      ))
                    )}
                  </div>
                </>
            </div>
        </div>

        <ModalDelete 
          showModalDelete={showModalDelete}
          closeModal={closeModalDelete}
          accept={handleConfirmDelete}
          textType="encuesta"
          pronoun="la"
        />

        <ModalSuccess 
          showModalSuccess={showModalSuccess}
          closeModalSuccess={closeModalSuccess}
          fill="green" 
          text={successMessage}
          excel={!!excelReport}
          excelData={excelReport}
        />

        <ModalAlertWarning 
          showModalAlertWarning={showModalAlertWarning}
          closeModal={closeModalAlertWarning}
          error={warningMessage}
          accept={closeModalAlertWarning}
          color={warningMessage.includes("No hay encuestas vigentes") ? "#FFC000" : "#CA2D00"}
        />

    </div>
  );
}